import { VFC } from 'react'
import { useAvailability } from '../Providers/Availability'
import { Content } from './Content'

const Day: VFC = () => {
  const { data } = useAvailability()

  return <Content availabilities={data} />
}

export { Day }
